import { css, cx } from '@linaria/core'
import { type FC, memo } from 'react'
import type { GroupDataEntry } from '#pages/Configuration/Comparison/useLinearizeComparisonData'
import { fragments, style } from '#styles/index'
import { useCurrencyFormatter } from '#utils/formatCurrency'
import type { ChangeTableContext } from '../useChangesTable'

const rowClass = css`
  display: grid;
  grid-column: 1/13;
  border-bottom: 1px solid ${style.themeColors.lineDefault};
  height: fit-content;
  min-height: 50px;
  

  ._left {
    display: flex;
    grid-column: 1/6;
    padding: 10px 28px 5px 25px;
    background-color: ${style.themeColors.backgroundBoxed};
    justify-content: space-between;
    align-items: flex-end;

    color: ${style.themeColors.textDimmed};

    > span {
      ${fragments.textStyle.heading.l.regular}
      overflow-x: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      text-overflow: ellipsis;
    }
    
    > ._sum {
      white-space: nowrap;
      display: flex;
      justify-content: flex-end;
    }
  }

  ._right {
    grid-column: 6/13;
    flex: 1;
    padding: 10px 20px 5px 20px;
    ${fragments.textStyle.heading.l.regular}
    background-color: ${style.themeColors.backgroundDefault};
 
    display: flex;
    align-items: flex-end;
    gap: 12px;
  }
`

export const ChangeSubGroupRow: FC<{ entry: GroupDataEntry; context: ChangeTableContext }> = memo(function ComparisonSubGroupRow({ entry, context }) {
  const delta = context.priceDeltas.byPath[entry.id]
  const currency = useCurrencyFormatter()

  return (
    <div className={cx('_row', rowClass)}>
      <div className="_left">
        <span>{entry.base?.title ?? entry.comparison?.title}</span>
        <div className="_sum">Σ {currency.formatDeltaCurrency(delta, { hideCurrencySymbol: true })}</div>
      </div>
      <div className="_right">{entry.base?.title ?? entry.comparison?.title}</div>
    </div>
  )
})
